import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  border-bottom: 1px solid ",
        ";\n  padding: 32px 0 20px 0;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 12px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  width: 44px;\n  height: 44px;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n  letter-spacing: -0.16px;\n\n  color: ",
        ";\n\n  span {\n    padding: 0 7px;\n    border-radius: 4px;\n    font-size: 12px;\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 2px;\n  align-items: center;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  padding: 9px 16px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n  color: ",
        ";\n  cursor: pointer;\n\n  span {\n    color: ",
        ";\n  }\n\n  :hover {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n  }\n  &.review_help_on {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  word-break: break-word;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 150% */\n  letter-spacing: -0.16px;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n\n  li {\n    padding: 4px 8px;\n    background-color: ",
        ";\n    border-radius: 4px;\n    color: ",
        ";\n    list-style: none;\n\n    &.grade_tag {\n      font-weight: 600;\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _tagged_template_literal([
        "\n  all: unset;\n\n  display: flex;\n  justify-content: right;\n  color: ",
        ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n  cursor: pointer;\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _tagged_template_literal([
        "\n  padding: 12px;\n  background-color: ",
        ";\n  border-radius: 6px;\n\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  @media (max-width: 768px) {\n  }\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _tagged_template_literal([
        "\n  p:last-child {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n  letter-spacing: -0.14px;\n  color: ",
        ";\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import Image from "next/image";
import Link from "next/link";
import { formatDateToDot } from "src/utils/formatting";
import styled from "styled-components";
import { ProductRating } from "..";
import { Sizes } from "../../icon/IconList";
const AuthorProduct = (param)=>{
    let { authorProduct , reviewItem  } = param;
    const { id , title , sourceTitle , imageUrl  } = authorProduct;
    return /*#__PURE__*/ _jsx(Link, {
        href: "/products/".concat(id),
        onClick: ()=>mixpanelEvent("Review Source Handout Clicked", {
                //mx-109
                "후기 ID": reviewItem.id,
                "Product ID": id,
                "Product Title": title,
                "based source product title": sourceTitle
            }),
        children: /*#__PURE__*/ _jsx(AuthorProductBox, {
            children: /*#__PURE__*/ _jsxs(ProductItem, {
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: imageUrl,
                        width: 34,
                        height: 48,
                        alt: "mock product image"
                    }),
                    /*#__PURE__*/ _jsxs(ProductInfo, {
                        children: [
                            /*#__PURE__*/ _jsx(ProductInfoTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(ProductInfoTitle, {
                                children: sourceTitle
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const ReviewRow = (param)=>{
    let { reviewItem , mutationCount , mutationDelete  } = param;
    const { id , userInfo , likeInfo , rating , gradeTagItems , contentsTagItems , message , messageStatus , createdAt , productInfo , isMine  } = reviewItem;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(RowBox, {
            children: [
                /*#__PURE__*/ _jsxs(Reviewer, {
                    children: [
                        /*#__PURE__*/ _jsxs(LeftBox, {
                            children: [
                                /*#__PURE__*/ _jsx(Avatar, {
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: userInfo.profileImage,
                                        fill: true,
                                        alt: "mock profile image"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Info, {
                                    children: [
                                        /*#__PURE__*/ _jsxs(InfoName, {
                                            children: [
                                                userInfo.nickname,
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: userInfo.job
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Rating, {
                                            children: [
                                                /*#__PURE__*/ _jsx(ProductRating, {
                                                    precision: 0.1,
                                                    value: rating,
                                                    readOnly: true,
                                                    size: Sizes.small
                                                }),
                                                /*#__PURE__*/ _jsx(ReviewDate, {
                                                    children: createdAt ? formatDateToDot(createdAt).slice(2) : ""
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(UserHelpButton, {
                            onClick: ()=>{
                                mutationCount({
                                    id: id,
                                    status: likeInfo.isOn ? "off" : "on"
                                });
                                mixpanelEvent("Review Thanks Button Clicked", {
                                    //mx-110 채워야 할 항목은 배포전에 확인해야할듯 합니다.
                                    "후기 ID": id,
                                    "Product ID": (productInfo === null || productInfo === void 0 ? void 0 : productInfo.id) ? productInfo.id : "",
                                    "Product Title": productInfo === null || productInfo === void 0 ? void 0 : productInfo.title
                                });
                            },
                            className: likeInfo.isOn ? "review_help_on" : "",
                            children: [
                                "도움이 됐어요",
                                /*#__PURE__*/ _jsx("span", {
                                    children: likeInfo.count
                                })
                            ]
                        })
                    ]
                }),
                productInfo && /*#__PURE__*/ _jsx(AuthorProduct, {
                    authorProduct: productInfo,
                    reviewItem: reviewItem
                }),
                /*#__PURE__*/ _jsx(Contents, {
                    children: message
                }),
                /*#__PURE__*/ _jsxs(ReviewTag, {
                    children: [
                        gradeTagItems.map((tag, index)=>{
                            return /*#__PURE__*/ _jsx("li", {
                                className: "grade_tag",
                                children: tag
                            }, index);
                        }),
                        contentsTagItems.map((tag, index)=>{
                            return /*#__PURE__*/ _jsx("li", {
                                children: tag
                            }, index);
                        })
                    ]
                }),
                isMine && /*#__PURE__*/ _jsx(DeleteWrapper, {
                    children: /*#__PURE__*/ _jsx(DeleteButton, {
                        onClick: ()=>{
                            mutationDelete(id);
                            ;
                            mixpanelEvent("Review Delete Button Clicked ", {
                                //mx-112 채워야 할 항목은 배포전에 확인해야할듯 합니다.
                                "후기 ID": id,
                                "Product Id": productInfo === null || productInfo === void 0 ? void 0 : productInfo.id,
                                "Product Title": productInfo === null || productInfo === void 0 ? void 0 : productInfo.title
                            });
                        },
                        children: "내 후기 삭제하기"
                    })
                })
            ]
        })
    });
};
const RowBox = styled.div.withConfig({
    componentId: "sc-68826ff0-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_50);
const Reviewer = styled.div.withConfig({
    componentId: "sc-68826ff0-1"
})(_templateObject1());
const LeftBox = styled.div.withConfig({
    componentId: "sc-68826ff0-2"
})(_templateObject2());
const Avatar = styled.span.withConfig({
    componentId: "sc-68826ff0-3"
})(_templateObject3());
const Info = styled.div.withConfig({
    componentId: "sc-68826ff0-4"
})(_templateObject4());
const InfoName = styled.p.withConfig({
    componentId: "sc-68826ff0-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_900, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_50);
// const InfoType = styled.span``
const Rating = styled.div.withConfig({
    componentId: "sc-68826ff0-6"
})(_templateObject6());
const ReviewDate = styled.p.withConfig({
    componentId: "sc-68826ff0-7"
})(_templateObject7(), (props)=>props.theme.new.colors.sol_gray_300);
const UserHelpButton = styled.button.withConfig({
    componentId: "sc-68826ff0-8"
})(_templateObject8(), (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_blue_500, (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_50);
const Contents = styled.p.withConfig({
    componentId: "sc-68826ff0-9"
})(_templateObject9(), (props)=>props.theme.new.colors.sol_gray_700);
const ReviewTag = styled.div.withConfig({
    componentId: "sc-68826ff0-10"
})(_templateObject10(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.sol_mint_500, (props)=>props.theme.new.colors.sol_mint_50);
const DeleteWrapper = styled.div.withConfig({
    componentId: "sc-68826ff0-11"
})(_templateObject11());
const DeleteButton = styled.button.withConfig({
    componentId: "sc-68826ff0-12"
})(_templateObject12(), (props)=>props.theme.new.colors.sol_red_400);
const AuthorProductBox = styled.div.withConfig({
    componentId: "sc-68826ff0-13"
})(_templateObject13(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_50);
const ProductItem = styled.div.withConfig({
    componentId: "sc-68826ff0-14"
})(_templateObject14());
const ProductInfo = styled.div.withConfig({
    componentId: "sc-68826ff0-15"
})(_templateObject15(), (props)=>props.theme.new.colors.sol_gray_500);
const ProductInfoTitle = styled.p.withConfig({
    componentId: "sc-68826ff0-16"
})(_templateObject16(), (props)=>props.theme.new.colors.sol_gray_700);
export default ReviewRow;
